module.exports = function () {
  return Promise.resolve({
    Database: function () {
      return {
        exec: function () {},
        close: function () {},
      };
    },
  });
};
